<template>
  <!-- 作業依頼編集（発注入力）ダイアログ -->
  <v-dialog v-model="showDialog" width="95vw" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>作業依頼入力</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseButtonClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>

          <v-row no-gutters>
            <v-col :cols="5">

              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <v-row no-gutters>
                    <v-col :cols="12">
                      <dd-sub-header>
                        <span style="display: inline-block;width:150px">作業依頼</span>
                        <dd-custom-button
                          color="green"
                          @click="onSagyobashoSearchButtonClick"
                          v-if="!uketsukeShoukaiFlg"
                          :minWidth="170"
                          :rounded="false"
                          :tooltipDelay="0"
                          tooltipText="過去に作業したことがある作業場所を検索できます<br/>サブ画面として開く一覧にて検索後、<br/>行を選択すると作業場所 郵便番号,作業場所 住所1 ~ 3が各入力項目に反映されます"
                          :tooltipBottom="true"
                          :enableToolTip="helpUseFlg"
                          >
                            <v-icon left>
                              mdi-download-box-outline
                            </v-icon>
                            作業場所検索
                          </dd-custom-button>
                        <span class="mt-5 ml-5" style="font-size:1.5rem;font-weight:bold;color:red;">
                          {{ sagyoYoteiSatSunCheck }}
                        </span>
                      </dd-sub-header>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="6">
                  <v-row no-gutters>
                    <v-col :cols="6" class="px-1">
                      <dd-date-box
                        label="作業依頼日"
                        v-model="rec.trHacchuKihon.hacchuYmd"
                        ref="hacchuYmd"
                        :readonly="uketsukeShoukaiFlg"
                        :required="true"
                        tooltipText="作業を依頼した日を入力します"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                    <v-col :cols="6" class="px-1">
                      <dd-text-box
                        label="発注番号"
                        v-model="rec.trHacchuKihon.hacchuNo"
                        ref="hacchuNo"
                        :length="100"
                        :valueType="Ctrls.InputTypes.Free"
                        :readonly="true"
                        tooltipText="システムで自動採番される番号です<br/>修正は出来ません"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col :cols="6">
                  <v-row no-gutters>
                    <v-col :cols="6" class="px-0">
                      <div class="tgCheckbox">
                        <dd-checkbox
                          label="別メールで依頼済み"
                          v-model="rec.trHacchuMeisai.ryokinCalcFlg6"
                          ref="ryokinCalcFlg6"
                          :readonly="uketsukeShoukaiFlg"
                          tooltipText="既に他受付,別システムで依頼メールを送信している場合にチェックしてください"
                          :tooltipTop="true"
                          :enableToolTip="helpUseFlg"
                          />
                      </div>
                    </v-col>
                    <v-col :cols="6" class="px-1">
                      <dd-text-box
                        label="作業依頼ステータス"
                        v-model="sagyoIraiStatus"
                        ref="sagyoIraiStatus"
                        :length="100"
                        :valueType="Ctrls.InputTypes.Free"
                        :readonly="true"
                        tooltipText="依頼メールの状況により推移します<br/>作業依頼メール仮保存済み：作業依頼メールを仮保存した状態です<br/>別メールで依頼済み：別メールで依頼済みにチェックをしている状態です<br/>作業依頼メール送信済み：作業依頼メールを送信した状態です<br/>作業依頼メール送信失敗：作業依頼メールの送信で失敗している状態です<br/>支払確定済み：請求を確定にチェックをした状態です"
                        :tooltipLeft="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="6" class="px-1">
                  <dd-code-text-box
                    label="作業依頼先"
                    v-model="rec.trHacchuKihon.hacchusakiId"
                    ref="hacchusakiId"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="作業者"
                    return-value-name="id"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="mstTorihikisakiHeaders"
                    :itemList="filteredMstTorihikisaki"
                    :readonly="uketsukeShoukaiFlg"
                    :required="true"
                    tooltipText="作業依頼を行う相手を入力します<br/><br/>依頼メールの宛先にメールアドレスが自動でセットされます 変更は可能です"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :cols="5"  class="px-1">
                  <dd-code-text-box
                    label="作業担当者"
                    v-model="rec.trHacchuMeisai.sagyoTantoshaId"
                    ref="sagyoTantoshaId"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="作業担当者"
                    return-value-name="id"
                    item-value="jininCd"
                    item-text="jininNmSei"
                    :headerList="mstJininHeaders"
                    :itemList="filteredTantoshaList"
                    :readonly="uketsukeShoukaiFlg"
                    tooltipText="作業者コード/名称が会社の場合、作業担当者を入力します<br/><br/>依頼メールの宛先にメールアドレスが自動でセットされます 変更は可能です<br/>#作業依頼メールに反映"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :cols="1" class="pt-1">
                  <dd-icon-button-with-tooltip
                    icon="mdi-account-plus"
                    @click="isShowIraisaki2 = true"
                    :disabled="isShowIraisaki2"
                    message="２人目の依頼先欄を表示します"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters v-show="isShowIraisaki2">
                <v-col :cols="6" class="px-1">
                  <dd-code-text-box
                    label="作業依頼先(２人目)"
                    v-model="rec.trHacchuMeisai.sagyoIraisakiId2"
                    ref="hacchusakiId2"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="作業者"
                    return-value-name="id"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="mstTorihikisakiHeaders"
                    :itemList="filteredMstTorihikisaki"
                    :readonly="uketsukeShoukaiFlg"
                    tooltipText="作業依頼を行う相手を入力します<br/><br/>依頼メールの宛先にメールアドレスが自動でセットされます 変更は可能です"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :cols="5" class="px-1">
                  <dd-code-text-box
                    label="作業担当者（２人目）"
                    v-model="rec.trHacchuMeisai.sagyoTantoshaId2"
                    ref="sagyoTantoshaId2"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="作業担当者"
                    return-value-name="id"
                    item-value="jininCd"
                    item-text="jininNmSei"
                    :headerList="mstJininHeaders"
                    :itemList="filteredTantoshaList2"
                    :readonly="uketsukeShoukaiFlg"
                    tooltipText="作業者コード/名称が会社の場合、作業担当者を入力します<br/><br/>依頼メールの宛先にメールアドレスが自動でセットされます 変更は可能です<br/>#作業依頼メールに反映"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :cols="1" class="pt-1">
                  <dd-icon-button-with-tooltip
                    icon="mdi-account-plus"
                    @click="isShowIraisaki3 = true"
                    :disabled="isShowIraisaki3"
                    message="３人目の依頼先欄を表示します"
                  />
                  <dd-icon-button-with-tooltip
                    icon="mdi-account-minus"
                    @click="onClickCloseIraisaki2"
                    :disabled="isShowIraisaki3"
                    message="２人目の依頼先欄を非表示にします"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters v-show="isShowIraisaki3">
                <v-col :cols="6" class="px-1">
                  <dd-code-text-box
                    label="作業依頼先(３人目)"
                    v-model="rec.trHacchuMeisai.sagyoIraisakiId3"
                    ref="hacchusakiId3"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="作業者"
                    return-value-name="id"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="mstTorihikisakiHeaders"
                    :itemList="filteredMstTorihikisaki"
                    :readonly="uketsukeShoukaiFlg"
                    tooltipText="作業依頼を行う相手を入力します<br/><br/>依頼メールの宛先にメールアドレスが自動でセットされます 変更は可能です"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                  />
                </v-col>
                <v-col :cols="5" class="px-1">
                  <dd-code-text-box
                    label="作業担当者（３人目）"
                    v-model="rec.trHacchuMeisai.sagyoTantoshaId3"
                    ref="sagyoTantoshaId2"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Alphanumeric"
                    titleText="作業担当者"
                    return-value-name="id"
                    item-value="jininCd"
                    item-text="jininNmSei"
                    :headerList="mstJininHeaders"
                    :itemList="filteredTantoshaList3"
                    :readonly="uketsukeShoukaiFlg"
                    tooltipText="作業者コード/名称が会社の場合、作業担当者を入力します<br/><br/>依頼メールの宛先にメールアドレスが自動でセットされます 変更は可能です<br/>#作業依頼メールに反映"
                    :tooltipBottom="true"
                    :enableToolTip="helpUseFlg"
                    />
                </v-col>
                <v-col :cols="1" class="pt-1">
                  <dd-icon-button-with-tooltip
                    icon="mdi-account-minus"
                    @click="onClickCloseIraisaki3"
                    message="３人目の依頼先欄を非表示にします"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="6">
                  <v-row no-gutters>
                    <v-col :cols="5" class="px-1">
                      <dd-text-box
                        label="電話番号"
                        v-model="rec.trHacchuMeisai.denpyoBiko1"
                        ref="denpyoBiko1"
                        :length="15"
                        :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                        :readonly="uketsukeShoukaiFlg"
                        tooltipText="作業担当者の連絡先を入力します"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                    <v-col :cols="5" class="px-1">
                      <dd-drop-down
                        label="支払ランク"
                        placeholder="選択して下さい"
                        v-model="rec.trHacchuMeisai.denpyoHanyoSbt3"
                        ref="denpyoHanyoSbt3"
                        :items="filteredShiharaiRankSbtList"
                        :readonly="uketsukeShoukaiFlg||sharyoSagyoBuzaiInputFlg"
                        tooltipText="支払単価のランクを選択します<br/>作業者の支払ランクが自動でセットされますが変更は可能です"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="6">
                  <v-row no-gutters>
                    <div style="width: 48%;" class="px-1">
                      <dd-date-box
                        label="作業予定日FROM"
                        v-model="rec.trHacchuMeisai.hatsuchiYmd"
                        ref="hatsuchiYmd"
                        :readonly="uketsukeShoukaiFlg"
                      tooltipText="作業予定日の開始日を入力します<br/>複数日にまたがる場合には作業予定日Toも合わせて入力してください<br/><br/>#作業依頼メールに反映"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </div>
                    <div style="width: 4%;" class="mt-2 mp-0">～</div>
                    <div style="width: 48%;" class="px-1">
                      <dd-date-box
                        label="作業予定日TO"
                        v-model="rec.trHacchuMeisai.chakuchiYmd"
                        ref="chakuchiYmd"
                        :readonly="uketsukeShoukaiFlg"
                      tooltipText="作業予定日の終了日が開始日と異なる場合に入力してください"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </div>
                  </v-row>
                </v-col>
                <v-col :cols="6">
                  <v-row no-gutters>
                    <v-col :cols="12" class="px-1">
                      <dd-text-box
                        label="作業開始時間"
                        v-model="rec.trHacchuMeisai.denpyoBiko2"
                        ref="denpyoBiko2"
                        :length="20"
                        :valueType="Ctrls.InputTypes.Free"
                        :readonly="uketsukeShoukaiFlg"
                        tooltipText="現地到着時間を入力します。<br/>AM,PM,１０～１１時の間というような入力も可能です"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="12">
                  <v-row no-gutters>
                    <v-col :cols="3" class="px-1">
                      <dd-text-box
                        label="作業場所 郵便番号"
                        v-model="rec.trHacchuMeisai.sagyobashoYubinNo"
                        ref="sagyobashoYubinNo"
                        :length="8"
                        :appendValidators="[Validators.postCodeValidate]"
                        :appendFormatter="(p) => Complement.parsePostCode(p)"
                        :appendUnFormatter="(p) => Complement.unformatPostCode(p)"
                        :valueType="Ctrls.InputTypes.AlphanumericWithSymbol"
                        @blur="onToritsukesakiYubinInputBlur"
                        @focus="onToritsukesakiYubinInputFocus"
                        :readonly="uketsukeShoukaiFlg"
                        tooltipText="作業場所住所の郵便番号を入力します<br/><br/>7桁入力すると自動で000-0000形式に変換されます<br/><br/>#入力推奨 #作業依頼メールに反映"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                    <v-col :cols="9" class="px-1">
                      <dd-text-box
                        label="作業場所 住所1"
                        v-model="rec.trHacchuMeisai.sagyobashoJusho1"
                        ref="sagyobashoJusho1"
                        :length="100"
                        :valueType="Ctrls.InputTypes.Free"
                        :readonly="uketsukeShoukaiFlg"
                        tooltipText="作業場所の住所を入力します<br/>#入力推奨 #作業依頼メールに反映"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="12">
                  <v-row no-gutters>
                    <v-col :cols="3" class="px-1" />
                    <v-col :cols="9" class="px-1">
                      <dd-text-box
                        label="作業場所 住所2"
                        v-model="rec.trHacchuMeisai.sagyobashoJusho2"
                        ref="sagyobashoJusho2"
                        :length="100"
                        :valueType="Ctrls.InputTypes.Free"
                        :readonly="uketsukeShoukaiFlg"
                        tooltipText="作業場所の住所の詳細情報を入力します<br/>住所１に全て入れても問題ありませんが、<br/>住所で検索する等のことも考慮し<br/>適切に分けるようにしましょう<br/>#入力推奨 #作業依頼メールに反映"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col :cols="12">
                  <v-row no-gutters>
                    <v-col :cols="3" class="px-1" />
                    <v-col :cols="9" class="px-1">
                      <dd-text-box
                        label="作業場所 住所3"
                        v-model="rec.trHacchuMeisai.sagyobashoJusho3"
                        ref="sagyobashoJusho3"
                        :length="100"
                        :valueType="Ctrls.InputTypes.Free"
                        :readonly="uketsukeShoukaiFlg"
                        tooltipText="作業場所の住所の詳細情報を入力します<br/>住所１,２に全て入れても問題ありませんが、<br/>住所で検索する等のことも考慮し<br/>適切に分けるようにしましょう<br/>#作業依頼メールに反映"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters>

                <v-col :cols="12">
                  <v-row no-gutters>
                    <v-col :cols="12" class="px-1">
                      <div class="vptextarea">
                        <dd-text-area
                          label="作業依頼備考"
                          v-model="rec.trHacchuMeisai.biko"
                          ref="biko"
                          :length="4000"
                          :valueType="Ctrls.InputTypes.Free"
                          :readonly="uketsukeShoukaiFlg"
                          rows="4"
                          appendPlaceHolder="※センドバックの場合、テンプレの備考に反映させたい内容を入力しましょう"
                          tooltipText="作業依頼に関する付帯情報を入力します"
                          :tooltipBottom="true"
                          :enableToolTip="helpUseFlg"
                          />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <!--
                <v-col :cols="6">
                  <v-row no-gutters>
                    <v-col :cols="3" class="px-1"></v-col>
                    <v-col :cols="3" class="px-1"></v-col>
                    <v-col :cols="3" class="px-1"></v-col>
                    <v-col :cols="3" class="px-1">
                      <dd-numeric-box
                        label="支払金額計"
                        v-model="shiharaiKingakuKei"
                        :integerDigit="10"
                        :minorDigit="0"
                        :length="10"
                        :max=9999999999
                        :min=-9999999999
                        suffix="円"
                        :readonly="true"
                        tooltipText="選択している作業車両の支払金額合計を表示します"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
                -->
              </v-row>

              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <dd-sub-header>
                    作業車両
                  </dd-sub-header>
                  <span class="ml-1 view-description"><v-icon color="green" small>mdi-information-outline</v-icon>作業依頼する車両にチェックを入れてください（※グレーは依頼済み車両）</span>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="8" class="px-1">
                  <dd-narrow-down-text-box
                    adjustStyle="padding-top: 4px !important"
                    v-model="sharyoSearchText"
                    :length="50"
                    :readonly="uketsukeShoukaiFlg"
                    />
                </v-col>
                <v-col :cols="2" class="px-1">
                  <dd-row-count-box
                    adjustStyle="padding-top: 4px !important"
                    label="総数"
                    v-model="sharyoRowCount"
                    />
                </v-col>
                <v-col :cols="2" class="px-1">
                  <dd-row-count-box
                    adjustStyle="padding-top: 4px !important"
                    label="表示件数"
                    v-model="filteredSharyoRowCount"
                    />
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col :cols="6">
                  <v-row no-gutters>
                    <v-col :cols="4" class="px-1">
                      <dd-numeric-box
                        label="依頼台数"
                        v-model="iraiDaisu"
                        :integerDigit="10"
                        :minorDigit="0"
                        :length="10"
                        :max=9999999999
                        :min=-9999999999
                        suffix="台"
                        :readonly="true"
                        tooltipText="選択されている車両の台数合計が表示されます"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                    <v-col :cols="8" class="px-1">
                      <div class="tgCheckbox">
                        <dd-checkbox
                          label="車両を特定せずに依頼する"
                          v-model="rec.trHacchuMeisai.ryokinCalcFlg3"
                          ref="ryokinCalcFlg3"
                          :readonly="uketsukeShoukaiFlg"
                          tooltipText="チェックをOnにすると台数での作業依頼が可能となります<br/>作業車両が特定できない場合にはこのチェックをOnにして依頼してください<br/>依頼メールの依頼台数が指定依頼台数から表示されるようになります"
                          :tooltipBottom="true"
                          :enableToolTip="helpUseFlg"
                          />
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="spx" />
                </v-col>
                <v-col :cols="6" v-if="rec.trHacchuMeisai.ryokinCalcFlg3">
                  <v-row no-gutters>
                    <v-col :cols="6" class="px-1">
                      <dd-numeric-box
                        label="指定依頼台数"
                        v-model="rec.trHacchuMeisai.yoteiSagyoJikan"
                        ref="yoteiSagyoJikan"
                        :integerDigit="10"
                        :minorDigit="0"
                        :length="10"
                        :max=9999999999
                        :min=-9999999999
                        suffix="台"
                        :readonly="uketsukeShoukaiFlg"
                        tooltipText="台数で依頼する場合に入力します<br/>依頼メールの依頼台数が指定依頼台数から表示されるようになります"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters justify="end" v-show="filteredSharyoRows.length > vitemsPerPage">
                <dd-select-items-per-page
                  ref="pagination1"
                  :itemsPerPage.sync="vitemsPerPage"
                  :currentPage.sync="vPage"
                  :items="filteredSharyoRows"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-row>
              <v-row no-gutters class="pb-1" v-if="filteredSharyoRows.length > vitemsPerPage && !uketsukeShoukaiFlg">
                <v-col :cols="12" class="px-1">
                  <div class="tgCheckbox">
                    <dd-checkbox
                      label="全ての車両をチェックする"
                      v-model="allSharyoCheckFlg"
                      :readonly="uketsukeShoukaiFlg"
                      @change="onAllSharyoCheckFlgChange"
                      tooltipText="全ページの全車両にチェックします"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      />
                  </div>
                </v-col>
              </v-row>

              <v-row no-gutters class="mt-1">
                <v-col :cols="12">
                  <v-row no-gutters>
                    <v-col :cols="12" class="px-1">
                      <v-data-table
                        item-key="id"
                        width="100%"
                        :headers="sharyoHeaders"
                        :items="filteredSharyoRows"
                        :search="sharyoSearchText"
                        :custom-filter="filtering"
                        show-select
                        v-model="rec.trSagyoMeisai"
                        class="tableTextBox"
                        no-data-text="依頼できる車両が登録されていません"
                        :items-per-page="vitemsPerPage"
                        :page.sync="vPage"
                        fixed-header
                        calculate-widths
                        hide-default-footer
                        locale="ja-jp"
                        dense
                      >
                        <template v-slot:item="{ item, isSelected, select }">
                          <tr :class="item.isDisabled?'disabledRow':''">
                            <td>
                              <dd-checkbox
                                :input-value="isSelected"
                                :disabled="!item.isSelectable"
                                @change="select($event)"
                                />
                            </td>
                            <td v-for="header in sharyoHeaders" :class="(header.align?'text-'+header.align:'text-start')+' '+header.class" :key="header.value" @click="onSharyoEditClick(item)">
                              <div v-if="header.value==='jissekiMikakuninFlg'&![undefined, null, ''].includes(item.jissekiSagyoYmd)">
                                <v-icon v-if="item.checksheetCount > 0" color="red accent-4" style="font-size: 19.5px">mdi-file-pdf-box</v-icon>
                                <div v-else>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-on="on" v-bind="attrs" color="red accent-4" style="font-size: 19.5px">mdi-alert</v-icon>
                                    </template>
                                    <span>作業報告はありましたが、チェックシートがアップロードされていません</span>
                                  </v-tooltip>
                                </div>
                              </div>
                              <div class="tgTableIcon" v-if="header.value==='actions'&&!uketsukeShoukaiFlg">
                                <div v-if="item.delFlg===false">
                                  <dd-icon-button-with-tooltip
                                    message="車両の個別入力画面を表示します。"
                                    icon="mdi-pencil-box-outline"
                                    @click="onPopupSagyoSharyoEditOpen(item.index)"
                                  />
                                </div>
                              </div>
                              <div class="tgTableIcon" v-if="header.value==='sagyoKanryoFlgDisp'">
                                <v-icon small v-if="item.sagyoKanryoFlg">mdi-check-bold</v-icon>
                                <v-icon small v-if="item.sagyoCancelFlg">mdi-cancel</v-icon>
                              </div>
                              <div v-if="header.value !== 'jissekiMikakuninFlg' && header.value !== 'actions'">
                                {{ item[header.value] }}
                              </div>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters justify="end" v-show="filteredSharyoRows.length > vitemsPerPage">
                <dd-select-items-per-page
                  ref="pagination2"
                  :itemsPerPage.sync="vitemsPerPage"
                  :currentPage.sync="vPage"
                  :items="filteredSharyoRows"
                  @changeItemsPerPage="changeItemsPerPage"
                  @changePage="changePage"
                />
              </v-row>
            </v-col>

            <v-col :cols="7" class="pl-2"
              @dragover.prevent
              @dragenter="onDragEnter"
              @dragleave="onDragLeave"
              @drop="onDrop"
            >
              <v-card class="ma-0 pa-0" elevation="0" :disabled="trHacchuMeisaiId === 0">
                <v-row no-gutters>
                  <v-col :cols="12">
                    <dd-sub-header>
                      <v-row no-gutters>
                        <v-col :cols="2">
                          <span>依頼メール</span>
                        </v-col>
                        <v-col :cols="10" v-if="!uketsukeShoukaiFlg">
                          <v-row no-gutters justify="end" v-if="trHacchuMeisaiId !== 0">
                            <span style="display: inline-block;width:250px">
                              <dd-drop-down
                                class="template-select"
                                label="テンプレート"
                                v-model="templateId"
                                ref="templateId"
                                :items="filteredMailTemplateList"
                                :readonly="uketsukeShoukaiFlg"
                                tooltipText="利用したいテンプレートを選択します"
                                :tooltipBottom="true"
                                :enableToolTip="helpUseFlg"
                              />
                            </span>
                            <dd-custom-button
                              color="blue"
                              :minWidth="150"
                              :rounded="false"
                              :disabled="templateId === null"
                              @click="onTemplateButtonClick"
                              tooltipText="テンプレートを選択後、ボタンを押すことで本文が自動生成されます。"
                              :tooltipBottom="true"
                              :enableToolTip="helpUseFlg"
                              >
                              <v-icon>
                                mdi-download
                              </v-icon>
                              テンプレート適用
                            </dd-custom-button>
                          </v-row>
                          <span v-else class="ml-1 view-description">
                            <v-icon color="green" small>mdi-information-outline</v-icon>作業依頼保存後に編集可能になります。
                          </span>
                        </v-col>
                      </v-row>
                    </dd-sub-header>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col :cols="8">
                    <dd-custom-button
                      color="blue"
                      :minWidth="90"
                      :outlined="true"
                      :rounded="false"
                      @click="onSendButtonClick"
                      :tooltipDelay="0"
                      tooltipText="入力した内容でメール送信します"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      >
                      <v-icon color="blue">
                        mdi-email-arrow-right-outline
                      </v-icon>
                      送信
                    </dd-custom-button>

                    <dd-custom-button
                      color="blue"
                      :minWidth="120"
                      :outlined="true"
                      :rounded="false"
                      @click="onTemporarySaveButtonClick"
                      :tooltipDelay="0"
                      tooltipText="入力した内容を一時保存します。メールは送信されません。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      >
                      <v-icon color="blue">
                        mdi-email-variant
                      </v-icon>
                      一時保存
                    </dd-custom-button>

                    <dd-custom-button
                      color="blue"
                      :minWidth="90"
                      :outlined="true"
                      :rounded="false"
                      @click="addAttachmentsClick"
                      :tooltipDelay="0"
                      tooltipText="添付ファイルを追加できます。複数選択も可能です。"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      >
                      <v-icon color="blue">
                        mdi-paperclip
                      </v-icon>
                      添付
                    </dd-custom-button>
                    <v-file-input
                      id="fileSelectInput"
                      v-model="fileSelectInput"
                      ref="fileSelectInput"
                      @change="changedFileSelect"
                      v-show="false"
                      multiple
                      >
                    </v-file-input>

                    <dd-custom-button
                      v-if="!uketsukeShoukaiFlg"
                      color="blue"
                      :minWidth="90"
                      :outlined="true"
                      :rounded="false"
                      @click="isShowCc = !isShowCc"
                      :tooltipDelay="0"
                      :tooltipText="isShowCc ? 'CCを非表示にします' : 'CCを表示します'"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      >
                      <v-icon v-if="!isShowCc" color="blue">
                        mdi-plus-circle
                      </v-icon>
                      <v-icon v-else color="blue">
                        mdi-close-circle
                      </v-icon>
                      CC
                    </dd-custom-button>

                    <dd-custom-button
                      v-if="!uketsukeShoukaiFlg"
                      color="blue"
                      :minWidth="90"
                      :outlined="true"
                      :rounded="false"
                      :tooltipDelay="0"
                      @click="isShowBcc = !isShowBcc"
                      :tooltipText="isShowBcc ? 'BCCを非表示にします' : 'BCCを表示します'"
                      :tooltipBottom="true"
                      :enableToolTip="helpUseFlg"
                      >
                      <v-icon v-if="!isShowBcc" color="blue">
                        mdi-plus-circle
                      </v-icon>
                      <v-icon v-else color="blue">
                        mdi-close-circle
                      </v-icon>
                      BCC
                    </dd-custom-button>

                  </v-col>
                  <v-col cols="4">
                    <v-row no-gutters justify="end">
                      <dd-checkbox
                        class="px-2"
                        label="宛先・CC・BCCにメールアドレスを表示する"
                        v-model="isShowMailAddress"
                        tooltipText="チェックONにすると、宛先/CC/BCCにメールアドレスが表示され、検索対象にできます"
                        :tooltipTop="true"
                        :enableToolTip="helpUseFlg"
                      />
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="mt-1">
                  <v-col cols="1" class="px-2">
                      <div style="padding-top: 7px !important; font-weight: bold">宛先</div>
                  </v-col>
                  <v-col cols="11" class="px-1">
                    <v-autocomplete
                      v-model="toAddressItems"
                      :items="filteredMailAddress"
                      placeholder="ここをクリックして選択してください。"
                      multiple
                      clearable
                      small-chips
                      deletable-chips
                      hideDetails='auto'
                      solo
                      flat
                      dense
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters class="mt-1" v-show="isShowCc">
                  <v-col cols="1" class="px-2">
                    <div style="padding-top: 7px !important; font-weight: bold">CC</div>
                  </v-col>
                  <v-col cols="11" class="px-1">
                    <v-autocomplete
                      v-model="ccAddressItems"
                      :items="filteredMailAddress"
                      placeholder="ここをクリックして選択してください。"
                      multiple
                      clearable
                      small-chips
                      deletable-chips
                      hideDetails='auto'
                      solo
                      flat
                      dense
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters class="mt-1" v-show="isShowBcc">
                  <v-col cols="1" class="px-2">
                    <div style="padding-top: 7px !important; font-weight: bold">BCC</div>
                  </v-col>
                  <v-col cols="11" class="px-1">
                    <v-autocomplete
                      v-model="bccAddressItems"
                      :items="filteredMailAddress"
                      placeholder="ここをクリックして選択してください。"
                      multiple
                      small-chips
                      deletable-chips
                      hideDetails='auto'
                      solo
                      flat
                      dense
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" class="px-2 pt-2">
                    <div style="font-weight: bold">件名</div>
                  </v-col>
                  <v-col cols="11" class="px-1">
                    <dd-text-box
                      v-model="rec2.trMailSndrcv.mailTitle"
                      ref="mailTitle"
                      :valueType="Ctrls.InputTypes.Free"
                      :readonly="uketsukeShoukaiFlg"
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters class="mt-1">
                  <v-col cols="1" class="px-2">
                    <v-row no-gutters>
                      <div style="font-weight: bold">添付</div>
                    </v-row>
                  </v-col>
                  <v-col cols="11" class="px-1">
                    <v-row no-gutters>
                      <div v-if="attachmentItems.length > 0">
                        <span class="pa-1" v-for="item in attachmentItems" v-bind:key="item.index">
                          <v-chip
                            close
                            small
                            @click:close="removeFile(item.index)"
                          >
                            {{ item.file.name.length > 100 ? item.file.name.slice(0,100) + '...(略)' : item.file.name }}
                            <span v-if="item.file.size !== null">
                            （
                            <span v-if="item.file.size > 1000">{{ Math.round(item.file.size / 1000).toLocaleString() }} KB</span>
                            <span v-else>{{ item.file.size }} B</span>
                            ）
                            </span>
                          </v-chip>
                        </span>
                      </div>
                      <div v-else style="width: 100%; background-color: #f5f5f5">
                        <span class="pa-1">添付から選択するかドラッグアンドドロップで追加できます。追加後は各ファイル末尾の<v-icon small>mdi-close-circle</v-icon>で削除できます。</span>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="1" class="pl-2">
                    <span style="display: inline-block;padding-top: 6px !important; font-weight: bold;">本文</span>
                    <span style="float:right;padding-top: 3px !important;">
                      <dd-icon-button-with-tooltip
                        v-if="isExistMailTextStorage"
                        message="直近で編集していたメール本文を読み出します。"
                        icon="mdi-backup-restore"
                        @click="onClickRestoreMailText()"
                        :xsmall="true"
                      />
                    </span>
                  </v-col>
                  <v-col cols="11" class="px-1" v-bind:style="mailStyles">
                    <!--
                    <div class="vptextarea">
                      <dd-text-area
                        v-model="rec2.trMailSndrcv.mailText"
                        :readonly="uketsukeShoukaiFlg"
                        :length="4000"
                        :valueType="Ctrls.InputTypes.Free"
                        rows="15"
                      />
                    </div>
                    -->
                    <dd-quill-editor
                      :content.sync="rec2.trMailSndrcv.mailText"
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters class="mt-0 mr-2" justify="end">
                  <dd-icon-button-with-tooltip
                    :disabled="mailContextHeight < 500"
                    message="本文の入力エリアを標準に戻します"
                    icon="mdi-arrow-expand-up"
                    @click="mailContextHeight = mailContextHeight - 200"
                    :small="false"
                    :xsmall="true"
                  />
                  <dd-icon-button-with-tooltip
                    :disabled="mailContextHeight > 1400"
                    message="本文の入力エリアを拡大します"
                    icon="mdi-arrow-expand-down"
                    @click="mailContextHeight = mailContextHeight + 200"
                    :small="false"
                    :xsmall="true"
                  />
                </v-row>

                <v-row no-gutters class="mt-3">
                  <v-col :cols="1" />
                  <v-col :cols="5">
                    <v-row no-gutters justify="start">
                      <dd-custom-button
                        color="blue"
                        :minWidth="120"
                        :outlined="true"
                        :rounded="false"
                        @click="onTemplateExcelDownload"
                        :loading="isExcelDownloader"
                        :tooltipDelay="0"
                        tooltipText="依頼書EXCELをダウンロードします"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        >
                        <v-icon color="blue">
                          mdi-download
                        </v-icon>
                        依頼書EXCEL DL
                      </dd-custom-button>
                      <a id="download" href="#" style="display: none">ダウンロード</a>
                    </v-row>
                  </v-col>
                  <v-col :cols="6">
                    <v-row no-gutters class="mr-10" justify="end">
                      <dd-custom-button
                        color="blue"
                        :minWidth="120"
                        :outlined="true"
                        :rounded="false"
                        @click="onTemporarySaveButtonClick"
                        :tooltipDelay="0"
                        tooltipText="入力した内容を一時保存します。メールは送信されません。"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        >
                        <v-icon color="blue">
                          mdi-email-variant
                        </v-icon>
                        一時保存
                      </dd-custom-button>
                      <dd-custom-button
                        class="ml-1"
                        color="blue"
                        :minWidth="120"
                        :outlined="true"
                        :rounded="false"
                        @click="onSendButtonClick"
                        :tooltipDelay="0"
                        tooltipText="入力した内容でメール送信します"
                        :tooltipBottom="true"
                        :enableToolTip="helpUseFlg"
                        >
                        <v-icon color="blue">
                          mdi-email-arrow-right-outline
                        </v-icon>
                        送信
                      </dd-custom-button>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- コンポーネント -->
          <tg-sagyobasho-search-dialog
            :id="sagyoIraiId"
            :showDialog="isShowSagyobashoSearchDialog"
            :toritsukesakiNm="param.toritsukesakiNm"
            @close="onSagyobashoSearchDialogClose"
          />

        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
          <v-col :cols="5">
            <v-row no-gutters>
              <dd-footer-button
                @click="onCloseButtonClick"
                tooltipText="この画面を終了して前の画面へ戻ります"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
                >
                <v-icon>mdi-window-close</v-icon>
                閉じる
              </dd-footer-button>
              <dd-custom-button
                color="red"
                :outlined="true"
                v-if="isShowDeleteButton"
                @click="onDeleteButtonClick"
                tooltipText="表示されている作業依頼を削除します<br/>削除したデータは元に戻せないため注意してください<br>※メール送信後は削除できません"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
              >
                <v-icon>mdi-delete-forever</v-icon>
                削除
              </dd-custom-button>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <dd-footer-button
                :loading="isSaveLoading"
                v-if="isShowSaveButton"
                @click="onSaveButtonClick"
                tooltipText="入力した作業依頼と作業車両を保存します<br>依頼メールに関しては保存されませんので注意してください"
                :tooltipTop="true"
                :enableToolTip="helpUseFlg"
                >
                <v-icon>mdi-database-import-outline</v-icon>
                作業依頼保存
              </dd-footer-button>
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdCustomButton from '@/components/DdCustomButton'
import DdDateBox from '@/components/DdDateBox'
import DdDropDown from '@/components/DdDropDown'
import DdFooterButton from '@/components/DdFooterButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdNumericBox from '@/components/DdNumericBox.vue'
import DdQuillEditor from '@/components/DdQuillEditor'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdTextArea from '@/components/DdTextArea'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import TgSagyobashoSearchDialog from '@/components/TgSagyobashoSearchDialog'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

import dolly from '@/rahmen/utils/dolly'
import filter from '@/rahmen/utils/filters'
import { ArrayFilter } from '@/rahmen/arrayFilter'
import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import YubinBango from 'yubinbango-core2'

// const ADDRESSDUPLICATEERRORMESSAGE = 'メールアドレスが重複しています。'
const MAILCONTEXTHEIGHT = 427
const ATTACHMENTDUPLICATEERRORMESSAGE = 'ファイル名が重複しています。'

export default {
  name: 'TgPopupSagyoIraiEdit',
  mixins: [flowMixin],
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdDateBox,
    DdDropDown,
    DdFooterButton,
    DdNarrowDownTextBox,
    DdNumericBox,
    DdQuillEditor,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdTextArea,
    DdIconButtonWithTooltip,
    TgSagyobashoSearchDialog
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 作業依頼キー
     */
    sagyoIraiId: Number,
    /**
     * 依頼メールキー
     */
    iraiMailId: Number,
    /**
     * 受注キー
     */
    juchuKihonId: Number,
    juchuMeisaiId: Number,
    /**
     * 拡張引数
     */
    param: Object,
    /**
     * 車両リスト
     */
    uketsukeSharyoList: {
      type: Array
    },
    /**
     * 選択車両リスト
     */
    seletedSharyoList: {
      type: Array
    },
    /**
     * 照会モード
     */
    uketsukeShoukaiFlg: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    // メインID
    isSaveLoading: false,
    trHacchuMeisaiId: 0,
    trMailSndrcvId: 0,
    // props.param対比用
    propsParam: {},

    Filters: new ArrayFilter([]),
    invalidMessage: '',
    // ページネーション用
    vitemsPerPage: 25,
    vPage: 1,
    // ヘッダー定義
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,

    sharyoHeaders: [
      { text: '', value: 'jissekiMikakuninFlg', class: 'px-0', cellClass: 'px-0', align: 'center', sortable: false },
      // { text: '項番', value: 'index' },
      { text: '#', value: 'keyNo', align: 'end', class: 'px-1', sortable: false },
      { text: '作業完了', value: 'sagyoKanryoFlgDisp', align: 'center', sortable: false },
      { text: '作業依頼先', value: 'iraisakiNm' },
      { text: '作業担当者', value: 'sagyoTantoshaNm', class: '' },
      { text: '新車番プレートNo', value: 'newShabanPlateNo' }
      // { text: '旧車番プレートNo', value: 'oldShabanPlateNo', class: '' },
      // { text: '新車台番号', value: 'newShadaiNo', class: '' },
      // { text: '旧車台番号', value: 'oldShadaiNo', class: '' },
      // { text: '車両型式', value: 'sharyoKeishiki', class: '' },
      // { text: '初年度登録', value: 'shonendoToroku', class: '' },
      // { text: '車両メーカー', value: 'sharyoMakerNm', class: '' },
      // { text: '車種', value: 'shashu', class: '' },
      // { text: 'バックアイ形式', value: 'backeyeKeishikiNm', class: '' },
      // { text: 'ETC管理番号', value: 'etcKanriNo', class: '' },
      // { text: 'ETC形式', value: 'etcKeishikiNm', class: '' },
      // { text: '新シリアル番号', value: 'newSerialNo', class: '' },
      // { text: '旧シリアル番号', value: 'oldSerialNo', class: '' },
      // { text: '冷凍機メーカー', value: 'refrigeratorMakerNm', class: '' },
      // { text: 'ドア番', value: 'doorNo', class: '' }
      // { text: '作業予定日', value: 'sagyoYoteiYmdDisp', align: 'center', class: '' },
      // { text: '商品', value: 'shohinNm' },
      // { text: '作業区分', value: 'sagyoKbnNm' },
      // { text: '請求作業金額', value: 'seikyuSagyoKingakuKeiDisp', align: 'end', class: '' },
      // { text: '請求部材金額', value: 'seikyuBuzaiKingakuKeiDisp', align: 'end', class: '' },
      // { text: '支払金額', value: 'shiharaiSagyoKingakuKeiDisp', align: 'end', class: '' }
    ],
    sharyoSearchText: '',
    allSharyoCheckFlg: false,

    modeKengen: 2,
    modeOfEdit: 2,

    templateId: null,

    isShowMailAddress: true,
    isShowCc: false,
    isShowBcc: false,
    isShowAddressSearchDialog: false,
    isShowSagyobashoSearchDialog: false,
    isShowSharyoEditDialog: false,

    isExcelDownloader: false,

    // 戻り値用定義
    rec: {
      trHacchuKihon: {},
      trHacchuMeisai: {},
      trSagyoMeisai: [],
      juchuKihonId: 0,
      juchuMeisaiId: 0,
      changedShiharaiKakuteiFlg: false,
      mailDraftFlg: false,
      cloneTrSagyoMeisai: []
    },
    rec2: {
      trMailSndrcv: {
        mailTitle: null,
        mailText: null,
        trMailSndrcvAddressList: [],
        trMailSndrcvAttachmentList: []
      },
      scheduleData: {
        ryokinCalcFlg4: false
      },
      juchuMeisaiId: 0
    },

    cloneShiharaiKakuteiFlg: false,
    savedToritsukeYubinNo: null,

    sharyoSagyoBuzaiInputFlg: false,

    isShowIraisaki2: false,
    isShowIraisaki3: false,

    toAddressItems: [],
    ccAddressItems: [],
    bccAddressItems: [],
    attachmentIndex: -1,
    attachmentItems: [],
    fileSelectInput: [],

    isLoading: false,

    // メール本文高さ
    mailContextHeight: MAILCONTEXTHEIGHT,

    // タイマーイベント用
    timerEvent: null,
    isExistMailTextStorage: false
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        this.trHacchuMeisaiId = this.sagyoIraiId
        this.trMailSndrcvId = this.iraiMailId
        this.mailContextHeight = MAILCONTEXTHEIGHT
        this.initialize(true)
      }
    },
    filteredSharyoRows: function () {
      this.sharyoSagyoBuzaiInputFlg = this.filteredSharyoRows.some((elem) => elem.isSelectable && elem.sagyoBuzaiInputFlg)
    },
    'rec.trHacchuKihon.hacchusakiId': function () {
      if (!this.isLoading) {
        if (this.rec.trHacchuKihon.hacchusakiId) {
          const iraisaki = this.torihikisakiList.find((elem) => elem.id === this.rec.trHacchuKihon.hacchusakiId)
          if (iraisaki) {
            if (iraisaki.torihikisakiBunruiKbn1 === '02') {
              this.rec.trHacchuMeisai.shiharaiTomeFlg = true
            }
            this.rec.trHacchuMeisai.denpyoHanyoSbt3 = iraisaki.torihikisakiBunruiKbn3
          }
        }
        this.rec.trHacchuMeisai.sagyoTantoshaId = null
      }
    }
  },
  mounted () {
    this.clear()
    this.timerEvent = setInterval(this.saveMailtext, 60000)
  },
  destroyed: function () {
    clearInterval(this.timerEvent)
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      jininList: 'DDMasters/mstJinin',
      tgMstJininList: 'DDMasters/tgMstJinin',
      mailTemplateList: 'DDMasters/mstMailTemplate',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      systemConfigList: 'DDMasters/msysSystemConfig',
      loginUserId: 'users/userId',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredMailAddress () {
      const target = filter.dateFormatter(new Date())
      const l = this.tgMstJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
      if (l.length === 0) { return [] }
      var defArray = []
      const resultArray = l.map(elem => {
        return {
          value: elem.mailAddress,
          text: this.isShowMailAddress ? elem.jininNmSei + ' <' + elem.mailAddress + '>' : elem.jininNmSei
        }
      })
      return defArray.concat(resultArray)
    },
    filteredMstTorihikisaki () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return (elem.hacchusakiFlg === true || elem.torihikisakiBunruiKbn1 === '02') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredTantoshaList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return self.jininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        // 未定の場合は表示しない
        if (self.rec.trHacchuKihon.hacchusakiId === 20000) return false
        const sagyoiraisaki = self.filteredMstTorihikisaki.find(elem2 => elem2.id === self.rec.trHacchuKihon.hacchusakiId)
        if (!sagyoiraisaki) {
          return false
        }
        return elem.shanaiBiko3 === sagyoiraisaki.torihikisakiCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredTantoshaList2 () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return self.jininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        // 未定の場合は表示しない
        if (self.rec.trHacchuMeisai.sagyoIraisakiId2 === 20000) return false
        const sagyoiraisaki = self.filteredMstTorihikisaki.find(elem2 => elem2.id === self.rec.trHacchuMeisai.sagyoIraisakiId2)
        if (!sagyoiraisaki) {
          return false
        }
        return elem.shanaiBiko3 === sagyoiraisaki.torihikisakiCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredTantoshaList3 () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return self.jininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        // 未定の場合は表示しない
        if (self.rec.trHacchuMeisai.sagyoIraisakiId3 === 20000) return false
        const sagyoiraisaki = self.filteredMstTorihikisaki.find(elem2 => elem2.id === self.rec.trHacchuMeisai.sagyoIraisakiId3)
        if (!sagyoiraisaki) {
          return false
        }
        return elem.shanaiBiko3 === sagyoiraisaki.torihikisakiCd && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // ドロップダウンアイテム
    filteredShiharaiRankSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT004')
    },
    filteredMailTemplateList () {
      var defArray = [{ value: null, text: '未選択' }]
      const target = filter.dateFormatter(new Date())
      const resultArray = this.mailTemplateList.filter((elem) => {
        return elem.specificProgramId === 'SAGYOIRAI'
      }).map((elem) => {
        elem.text = elem.templateNm
        elem.value = elem.id
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
      return defArray.concat(resultArray)
    },
    // 金額集計
    shiharaiKingakuKei () {
      return this.filteredSharyoRows.reduce((acc, cur) => {
        return cur.isSelectable ? (acc + cur.shiharaiKingakuKei ?? 0) : acc
      }, 0)
    },
    shiharaiChoseikomiKingakuKei () {
      return this.shiharaiKingakuKei + this.getNumber(this.rec.trHacchuMeisai.userKingakuKazei1)
    },
    iraiDaisu () {
      return this.rec.trSagyoMeisai.length
    },
    sagyoIraiStatus () {
      if (this.rec.trHacchuMeisai.unchinKakuteiFlg) return '支払確定済み'
      if (this.rec.trHacchuMeisai.ryokinCalcFlg5) return '作業依頼メール送信失敗'
      if (this.rec.trHacchuMeisai.trMailSndrcvId && !this.rec.mailDraftFlg) return '作業依頼メール送信済み'
      if (this.rec.trHacchuMeisai.ryokinCalcFlg6) return '別メールで依頼済み'
      if (this.rec.mailDraftFlg) return '作業依頼メール仮保存済み'
      return ''
    },
    isReadOnlyShiharaiTomeFlg () {
      console.log('★★★isReadOnlyShiharaiTomeFlg★★★', this.rec.trHacchuKihon.hacchusakiId)
      const jisha = this.torihikisakiList.filter(elem => elem.torihikisakiBunruiKbn1 === '02')
      if (jisha.some(elem => elem.id === this.rec.trHacchuKihon.hacchusakiId)) return true
      return false
    },
    filteredSharyoRows () {
      const self = this
      return this.uketsukeSharyoList.map((elem) => {
        const index = self.seletedSharyoList.length > 0 ? self.seletedSharyoList.findIndex((item) => item.id === elem.id) : -1
        const result = {
          ...elem,
          isDisabled: (elem.trHacchuMeisaiId !== self.trHacchuMeisaiId && elem.trHacchuMeisaiId !== null) || (elem.sagyoCancelFlg),
          isSelectable: (elem.trHacchuMeisaiId === self.trHacchuMeisaiId || elem.trHacchuMeisaiId === null) && !self.uketsukeShoukaiFlg
        }
        // 選択状態の引継ぎ
        if (index >= 0) {
          this.rec.trSagyoMeisai.push(result)
        }
        return result
      })
    },
    sharyoRowCount () {
      return this.filteredSharyoRows.length
    },
    filteredSharyoRowCount () {
      const headersValue = this.sharyoHeaders.map(elem => elem.value)
      return this.filteredSharyoRows.filter(row => {
        return headersValue.some(value => this.Filters.filter(row[value], this.sharyoSearchText, headersValue))
      }).length
      // return 0
    },
    jininAddressList () {
      const target = filter.dateFormatter(new Date())
      return this.tgMstJininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 表示制御
    isShowSaveButton () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1 && !this.uketsukeShoukaiFlg) {
        return true
      }
      return false
    },
    // isShoukaiMode () {
    //   return this.modeOfEdit === 1
    // }
    sagyoYoteiSatSunCheck () {
      // 作業予定日に土日が含まれる場合、赤文字
      if (this.rec.trHacchuMeisai.hatsuchiYmd || this.rec.trHacchuMeisai.chakuchiYmd) {
        if (this.rec.trHacchuMeisai.hatsuchiYmd) {
          // FROMが土日
          const hatsuchi = new Date(this.rec.trHacchuMeisai.hatsuchiYmd)
          if (hatsuchi.getDay() === 0 || hatsuchi.getDay() === 6) return '土日作業！！'
        }
        if (this.rec.trHacchuMeisai.chakuchiYmd) {
          // TOが土日
          const chakuchi = new Date(this.rec.trHacchuMeisai.chakuchiYmd)
          if (chakuchi.getDay() === 0 || chakuchi.getDay() === 6) return '土日作業！！'
        }
        if (this.rec.trHacchuMeisai.hatsuchiYmd && this.rec.trHacchuMeisai.chakuchiYmd) {
          const hatsuchi = new Date(this.rec.trHacchuMeisai.hatsuchiYmd)
          const chakuchi = new Date(this.rec.trHacchuMeisai.chakuchiYmd)
          const nissu = (chakuchi - hatsuchi) / 86400000
          if (nissu >= 7 || (hatsuchi.getDay() + nissu) >= 6) {
            // 日数が7日以上→必ず土日を含む
            // FROM+日数で土曜を超える
            return '土日作業！！'
          }
        }
      }
      return ''
    },
    isShowDeleteButton () {
      if (this.trHacchuMeisaiId > 0) {
        return true
      }
      return false
    },
    mailStyles () {
      return {
        '--content-height': this.mailContextHeight + 'px'
      }
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      console.log('getCloneTargetMethod', this.rec)
      return {
        rec: this.rec
      }
    },
    getCloneTargetMethod2: function () {
      return {
        toAddressItem: this.toAddressItems,
        ccAddressItem: this.ccAddressItems,
        bccAddressItem: this.bccAddressItems,
        attachmentItems: this.attachmentItems,
        rec2: this.rec2
      }
    },
    setCloneData: function (e) {
      this.cloneData = dolly.clone(this.getCloneTargetMethod())
    },
    setCloneData2: function (e) {
      this.cloneData2 = dolly.clone(this.getCloneTargetMethod2())
    },
    saveMailtext: function () {
      if (![undefined, null, ''].includes(this.rec2.trMailSndrcv.mailText)) {
        localStorage.setItem('mailText', this.rec2.trMailSndrcv.mailText)
        this.isExistMailTextStorage = true
      }
    },
    getNumber (value) {
      if (!value) {
        return 0
      } else if (isFinite(value)) {
        if (typeof value === 'number') {
          return value
        } else {
          return parseFloat(value)
        }
      } else if (typeof value === 'string') {
        const num = value.replace(/,/g, '')
        if (isFinite(num)) {
          return parseFloat(num)
        }
      }
      return 0
    },
    clear: function () {
      this.rec = {
        juchuKihonId: this.juchuKihonId,
        juchuMeisaiId: this.juchuMeisaiId,
        changedShiharaiKakuteiFlg: false,
        trHacchuKihon: {
          hacchuNo: null,
          hacchuYmd: date.getCurrentDate(),
          hacchusakiId: 20000
        },
        trHacchuMeisai: {
          unchinKakuteiFlg: false,
          unchinCheckTantoshaId: null,
          unchinCheckYmd: '',
          shiharaiYoteiYmd: '',
          hacchusakiId: 20000,
          sagyoTantoshaId: null,
          denpyoBiko1: null,
          denpyoHanyoSbt3: null,
          hatsuchiYmd: this.propsParam.hatsuchiYmd,
          chakuchiYmd: this.propsParam.chakuchiYmd,
          sagyobashoYubinNo: this.propsParam.sagyobashoYubinNo,
          sagyobashoJusho1: this.propsParam.sagyobashoJusho1,
          sagyobashoJusho2: this.propsParam.sagyobashoJusho2,
          sagyobashoJusho3: this.propsParam.sagyobashoJusho3,
          shiharaiTomeFlg: false,
          userKingakuKazei1: null,
          ryokinCalcFlg1: false,
          ryokinCalcFlg2: false,
          denpyoBiko2: null,
          ryokinCalcFlg3: false,
          yoteiSagyoJikan: null,
          ryokinCalcFlg4: false,
          biko: null,
          ryokinCalcFlg6: false,
          sagyoIraisakiId2: null,
          sagyoTantoshaId2: null,
          sagyoIraisakiId3: null,
          sagyoTantoshaId3: null
        },
        trSagyoMeisai: [],
        mailDraftFlg: false,
        cloneTrSagyoMeisai: []
      }
      this.rec2 = {
        trMailSndrcv: {
          mailTitle: null,
          mailText: null,
          sndrcvKbn: '01',
          trMailSndrcvAddressList: [],
          trMailSndrcvAttachmentList: []
        },
        scheduleData: {
          ryokinCalcFlg4: false
        },
        juchuMeisaiId: this.juchuMeisaiId
      }
      this.isShowIraisaki2 = false
      this.isShowIraisaki3 = false
      this.toAddressItems = []
      this.ccAddressItems = []
      this.bccAddressItems = []
      // 開始を+1して0からとする為、初期値を-1とする
      this.attachmentIndex = -1
      this.attachmentItems = []
      this.templateId = null
    },
    initialize: function (paramResetFlg) {
      if (this.showDialog) {
        if (paramResetFlg) {
          this.propsParam = Object.assign({}, this.param)
        }

        if (this.trHacchuMeisaiId <= 0) {
          this.clear()
          this.setCloneData()
          this.setCloneData2()
        } else {
          // 初期化
          this.clear()
          this.setSagyoIraiInfo()
        }
      }
    },
    onChangedShiharaiKakuteiFlg: function (e) {
      if (this.rec.trHacchuMeisai.unchinKakuteiFlg === true) {
        this.rec.trHacchuMeisai.unchinCheckTantoshaId = this.loginUserId
        this.rec.trHacchuMeisai.unchinCheckYmd = filter.dateFormatter(new Date())
      } else {
        this.rec.trHacchuMeisai.unchinCheckTantoshaId = null
        this.rec.trHacchuMeisai.unchinCheckYmd = null
      }
    },
    // onChangedSagyoIraisaki: function (e) {
    //   const iraisaki = this.torihikisakiList.find((elem) => elem.id === this.rec.trHacchuKihon.hacchusakiId)
    //   if (iraisaki) {
    //     if (iraisaki.torihikisakiBunruiKbn1 === '02') {
    //       this.rec.trHacchuMeisai.shiharaiTomeFlg = true
    //     }
    //     this.rec.trHacchuMeisai.denpyoHanyoSbt3 = iraisaki.torihikisakiBunruiKbn3
    //   }
    //   this.rec.trHacchuMeisai.sagyoTantoshaId = null
    // },
    closeDialog () {
      this.$emit('close')
    },
    onCloseButtonClick: function (e) {
      // 変更チェック
      const target = this.getCloneTargetMethod()
      const modified = this._compareClone(target)
      const target2 = this.getCloneTargetMethod2()
      const modified2 = this._compareClone2(target2)
      const p = modified || modified2 ? modals.showConfirmYesNoCancelCustom : this._dummyPromiseMethod
      if (p !== this._dummyPromiseMethod) {
        p('TGRCOQ09', null, null, null, '保存して閉じる', '保存しないで閉じる').then((result) => {
          if (result.isConfirmed) {
            // 保存して閉じる
            if (modified2) {
              this.rec2.trMailSndrcv.draftFlg = true
              this.sendMailSave(false, modified, true)
            } else {
              if (modified) this.syncSagyoIrai(false)
              this.$nextTick(() => {
                this.closeDialog()
              })
            }
          } else if (result.isDenied) {
            // 保存しないで閉じる
            this.closeDialog()
          } else {
            // 何もしない
            return false
          }
        })
      } else {
        this.closeDialog()
      }
    },

    /* -------------------------------------------------------------------------------------------------------------- *
     * 作業依頼
     * -------------------------------------------------------------------------------------------------------------- */
    setSagyoIraiInfo: function () {
      // 登録済みデータ取得
      const self = this
      const option = {
        loadMasters: ['tgmstjinin', 'msyssystemconfig'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.clear()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('★★★savedInputRestorePromise★★★')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          console.log('★★★existsIdMethod★★★', self.trHacchuMeisaiId)
          return self.trHacchuMeisaiId !== 0
        },
        requestApiPromise: self.fetchSagyoIraiData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingItemMethod', kengen)
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    fetchSagyoIraiData: function () {
      const self = this
      return new Promise((resolve, reject) => {
        self.HttpClient
          .get(`/api/v1/Tgrcod002030/FindWithChildren2?id=${self.trHacchuMeisaiId}`)
          .then((data) => {
            console.log(data)
            if (data.payload) {
              self.isLoading = true
              self.rec = {
                ...data.payload,
                juchuKihonId: self.juchuKihonId,
                juchuMeisaiId: self.juchuMeisaiId,
                changedShiharaiKakuteiFlg: false,
                trHacchuKihon: {
                  ...data.payload.trHacchuKihon,
                  hacchuYmd: data.payload.trHacchuKihon.hacchuYmd ? filter.dateFormatter(data.payload.trHacchuKihon.hacchuYmd) : ''
                },
                trHacchuMeisai: {
                  ...data.payload.trHacchuMeisai,
                  unchinCheckYmd: data.payload.trHacchuMeisai.unchinCheckYmd ? filter.dateFormatter(data.payload.trHacchuMeisai.unchinCheckYmd) : '',
                  hatsuchiYmd: data.payload.trHacchuMeisai.hatsuchiYmd ? filter.dateFormatter(data.payload.trHacchuMeisai.hatsuchiYmd) : '',
                  chakuchiYmd: data.payload.trHacchuMeisai.chakuchiYmd ? filter.dateFormatter(data.payload.trHacchuMeisai.chakuchiYmd) : ''
                },
                mailDraftFlg: false
              }
              self.cloneShiharaiKakuteiFlg = self.rec.trHacchuMeisai.unchinKakuteiFlg
              self.sharyoSagyoBuzaiInputFlg = self.rec.trSagyoMeisai ? self.rec.trSagyoMeisai.some((elem) => elem.sagyoBuzaiInputFlg) : false

              // 依頼メール情報取得
              this.setIraiMailInfo()

              this.$nextTick(() => {
                if (![undefined, null, ''].includes(self.rec.trHacchuMeisai.sagyoIraisakiId2)) self.isShowIraisaki2 = true
                if (![undefined, null, ''].includes(self.rec.trHacchuMeisai.sagyoIraisakiId3)) self.isShowIraisaki3 = true
                self.isLoading = false
                this.setCloneData()
              })
            }
            resolve()
          })
          .catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            self.closeDialog()
            this.Effects.loadComplete()
            reject(e)
          })
      })
    },
    // --------------------------------------------------------------------------------------------------------------
    onSaveButtonClick: function (e) {
      this.syncSagyoIrai(true).then((rtn) => {
        if (rtn) {
          this.initialize(false)
        }
      })
    },
    syncSagyoIrai: function (messageFlg) {
      if (!this.sagyoIraiRegisterValidate()) return false

      const self = this
      return this.sagyoIraiSave(messageFlg).then((param) => {
        if (param.result) {
          self.trHacchuMeisaiId = param.data.payload.trHacchuMeisai.id
          // 取得情報設定
          self.propsParam = {
            ...this.propsParam,
            id: param.data.payload.trHacchuMeisai.id,
            hacchuNo: param.data.payload.trHacchuKihon.hacchuNo,
            hacchuYmd: param.data.payload.trHacchuKihon.hacchuYmd,
            hacchusakiId: param.data.payload.trHacchuKihon.hacchusakiId,
            sagyoIraisakiId: param.data.payload.trHacchuKihon.hacchusakiId,
            sagyoIraisakiNm: (param.data.payload.trHacchuKihon.hacchusakiId === null || param.data.payload.trHacchuKihon.hacchusakiId === '') ? '' : indexeddb.getRecord(self.torihikisakiList, param.data.payload.trHacchuKihon.hacchusakiId).torihikisakiNm,
            unchinKakuteiFlg: param.data.payload.trHacchuMeisai.unchinKakuteiFlg,
            unchinCheckTantoshaId: param.data.payload.trHacchuMeisai.unchinCheckTantoshaId,
            unchinCheckYmd: param.data.payload.trHacchuMeisai.unchinCheckYmd,
            shiharaiYoteiYmd: param.data.payload.trHacchuMeisai.shiharaiYoteiYmd,
            sagyoTantoshaId: param.data.payload.trHacchuMeisai.sagyoTantoshaId,
            sagyoTantoshaNm: (param.data.payload.trHacchuMeisai.sagyoTantoshaId === null || param.data.payload.trHacchuMeisai.sagyoTantoshaId === '') ? '' : indexeddb.getRecord(self.jininList, param.data.payload.trHacchuMeisai.sagyoTantoshaId).jininNmSei,
            denpyoBiko1: param.data.payload.trHacchuMeisai.denpyoBiko1,
            denpyoHanyoSbt3: param.data.payload.trHacchuMeisai.denpyoHanyoSbt3,
            hatsuchiYmd: param.data.payload.trHacchuMeisai.hatsuchiYmd,
            chakuchiYmd: param.data.payload.trHacchuMeisai.chakuchiYmd,
            sagyobashoYubinNo: param.data.payload.trHacchuMeisai.sagyobashoYubinNo,
            sagyobashoJusho1: param.data.payload.trHacchuMeisai.sagyobashoJusho1,
            sagyobashoJusho2: param.data.payload.trHacchuMeisai.sagyobashoJusho2,
            sagyobashoJusho3: param.data.payload.trHacchuMeisai.sagyobashoJusho3,
            shiharaiTomeFlg: param.data.payload.trHacchuMeisai.shiharaiTomeFlg,
            userKingakuKazei1: param.data.payload.trHacchuMeisai.userKingakuKazei1,
            ryokinCalcFlg1: param.data.payload.trHacchuMeisai.ryokinCalcFlg1,
            ryokinCalcFlg2: param.data.payload.trHacchuMeisai.ryokinCalcFlg2,
            denpyoBiko2: param.data.payload.trHacchuMeisai.denpyoBiko2,
            ryokinCalcFlg3: param.data.payload.trHacchuMeisai.ryokinCalcFlg3,
            yoteiSagyoJikan: param.data.payload.trHacchuMeisai.yoteiSagyoJikan,
            ryokinCalcFlg4: param.data.payload.trHacchuMeisai.ryokinCalcFlg4,
            biko: param.data.payload.trHacchuMeisai.biko,
            ryokinCalcFlg6: param.data.payload.trHacchuMeisai.ryokinCalcFlg6,
            iraiDaisu: param.data.payload.trSagyoMeisai.length,
            ryokinCalcFlg5: param.data.payload.trHacchuMeisai.ryokinCalcFlg5
          }
          // 自画面内車両一覧更新
          const selectSharyoList = Object.assign([], self.rec.trSagyoMeisai)
          self.uketsukeSharyoList.filter((elem) => elem.trHacchuMeisaiId === param.data.payload.trHacchuMeisai.id).map((elem) => {
            elem.trHacchuKihonId = null
            elem.trHacchuMeisaiId = null
            elem.iraisakiId = null
            elem.iraisakiNm = null
            elem.sagyoTantoshaId = null
            elem.sagyoTantoshaNm = null
          })
          // 依頼された車両を更新
          selectSharyoList.forEach((item) => {
            const index = self.uketsukeSharyoList.findIndex((elem) => elem.id === item.id)
            if (index >= 0) {
              self.uketsukeSharyoList[index].trHacchuKihonId = param.data.payload.trHacchuKihonId
              self.uketsukeSharyoList[index].trHacchuMeisaiId = param.data.payload.id
              self.uketsukeSharyoList[index].iraisakiId = param.data.payload.sagyoIraisakiId
              self.uketsukeSharyoList[index].iraisakiNm = param.data.payload.sagyoIraisakiNm
              self.uketsukeSharyoList[index].sagyoTantoshaId = param.data.payload.sagyoTantoshaId
              self.uketsukeSharyoList[index].sagyoTantoshaNm = param.data.payload.sagyoTantoshaNm
            }
          })
          self.rec.trSagyoMeisai = selectSharyoList
          self.$emit('edited', self.propsParam, selectSharyoList)

          return true
        }
      })
    },
    // --------------------------------------------------------------------------------------------------------------
    sagyoIraiSave: function (isSaveMessage) {
      this.isSaveLoading = true
      return new Promise(resolve => {
        const self = this
        if (this.validateAll(this.$refs)) {
          this.Effects.loadStart()
          self.sagyoIraiRegisterPromise().then(data => {
            console.log('registerRequestPromise', data)
            self.Effects.loadComplete()
            self.isSaveLoading = false
            if (!data.isValid) {
              if (data.summaryMessage && data.summaryMessage.messageCd) {
                modals.showAlert(data.summaryMessage.messageCd).then(() => {})
              }
              self.setInvalidMessage(self.$refs, data.invalidList)
              resolve({ result: false, data: null })
            } else {
              if (isSaveMessage && data.summaryMessage && data.summaryMessage.messageCd) {
                modals.showToastMessage(data.summaryMessage.messageCd, null, 2000, 400, null, 'success')
              }
              // 依頼先変更チェック(※依頼メール作成済みの場合のみ)
              if (self.trMailSndrcvId > 0) {
                if (self.cloneData.rec.trHacchuKihon.hacchusakiId !== data.payload.trHacchuKihon.hacchusakiId || self.cloneData.rec.trHacchuMeisai.sagyoTantoshaId !== data.payload.trHacchuMeisai.sagyoTantoshaId) {
                  modals.showToast('依頼先が変更されました。<br>依頼メールの宛先を見直してください。', 2000, 550, null, 'info')
                }
              }
              resolve({ result: true, data: data })
            }
          }).catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            self.Effects.loadComplete()
            self.isSaveLoading = false
            resolve({ result: false, data: null })
          })
        } else {
          resolve({ result: false, data: null })
        }
      })
    },
    sagyoIraiRegisterPromise: function () {
      let f
      this.rec = {
        ...this.rec,
        changedShiharaiKakuteiFlg: this.cloneShiharaiKakuteiFlg !== this.rec.trHacchuMeisai.unchinKakuteiFlg,
        trHacchuKihon: {
          ...this.rec.trHacchuKihon,
          unchinKakuteiFlg: this.rec.trHacchuMeisai.unchinKakuteiFlg,
          shiharaiTomeFlg: this.rec.trHacchuMeisai.shiharaiTomeFlg
        },
        trHacchuMeisai: {
          ...this.rec.trHacchuMeisai,
          iraiDaisu: this.iraiDaisu,
          yoteiSagyoJikan: this.rec.trHacchuMeisai.ryokinCalcFlg3 ? this.rec.trHacchuMeisai.yoteiSagyoJikan : null
        }
      }
      if (this.trHacchuMeisaiId === 0) {
        console.log('★登録処理', this.rec)
        f = this.HttpClient.post('/api/v1/Tgrcod002030/CreateWithChildren', this.rec)
      } else {
        console.log('★更新処理', this.rec)
        f = this.HttpClient.put(`/api/v1/Tgrcod002030/UpdateWithChildren?id=${this.trHacchuMeisaiId}`, this.rec)
      }
      return f
    },
    sagyoIraiRegisterValidate: function () {
      var ret = true
      if ([undefined, null, ''].includes(this.rec.trHacchuKihon.hacchusakiId)) {
        modals.showToastMessage('COME0001', null, 2000, 400, null, 'error')
        ret = false
      }
      console.log('cloneData', this.cloneData)
      return ret
    },

    /* -------------------------------------------------------------------------------------------------------------- *
     * メール送信
     * -------------------------------------------------------------------------------------------------------------- */
    onTemporarySaveButtonClick () {
      this.saveCheckBeforeOpenDialogPromise().then((ok) => {
        if (ok) {
          this.rec2.trMailSndrcv.draftFlg = true
          this.sendMailSave(true, false, false)
          return true
        }
      })
    },
    onSendButtonClick () {
      this.saveCheckBeforeOpenDialogPromise().then((ok) => {
        if (ok) {
          modals.showConfirmYesNo('TGRCOQ05').then((ok) => {
            if (ok !== false && ok !== undefined) {
              this.rec2.trMailSndrcv.draftFlg = false
              this.sendMailSave(true, false, true)
              return true
            }
          })
        }
      })
    },
    // --------------------------------------------------------------------------------------------------------------
    setIraiMailInfo () {
      console.log('★★★initialize★★★')
      this.isExistMailTextStorage = ![undefined, null, ''].includes(localStorage.getItem('mailText'))

      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('★★★savedInputRestorePromise★★★')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          console.log('★★★existsIdMethod★★★', self.id)
          // ★★★★★★初回登録でも取得処理有★★★★★★
          return true
        },
        requestApiPromise: self.fetchIraiMailData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingItemMethod', kengen)
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    fetchIraiMailData: function () {
      const self = this
      return new Promise((resolve, reject) => {
        let f
        if (self.trMailSndrcvId <= 0) {
          const param = {
            juchuMeisaiId: self.juchuMeisaiId,
            hacchuMeisaiId: self.trHacchuMeisaiId,
            templateId: 0
          }
          f = self.HttpClient.post('/api/v1/Tgrcod002050/GetInitialiMailItems2', param)
        } else {
          f = self.HttpClient.get(`/api/v1/Tgrcod002050/FindWithChildren?id=${self.trMailSndrcvId}`)
        }
        f.then((data) => {
          console.log('fetchData', data)
          if (data.payload) {
            this.assignIraiMailData(data.payload)

            this.$nextTick(() => {
              this.setCloneData2()
            })
          }
          resolve()
        }).catch((e) => {
          console.log('error', e)
          modals.showError(e.message)
          self.closeDialog(false)
          this.Effects.loadComplete()
          reject(e)
        })
      })
    },
    assignIraiMailData: function (data) {
      console.log('assignIraiMailData', data)
      const scheduleBase = {
        hacchuNo: this.rec.trHacchuKihon.hacchuNo,
        tokuisakiNm: this.propsParam.tokuisakiNm,
        toritsukesakiNm: this.propsParam.toritsukesakiNm,
        sagyoKbnNm: this.propsParam.sagyoKbn,
        title: (this.propsParam.toritsukesakiNm ?? '') + ' ' + (this.propsParam.sagyoKbn ?? '') + (this.propsParam.iraiDaisu ?? '') + '台' + '「' + this.rec.trHacchuKihon.hacchuNo + '」',
        sagyobasho: (this.rec.trHacchuMeisai.sagyobashoJusho1 ?? '') + (this.rec.trHacchuMeisai.sagyobashoJusho2 ?? '') + (this.rec.trHacchuMeisai.sagyobashoJusho3 ?? ''),
        sharyoTantoshaIds: this.rec.trHacchuMeisai.sharyoTantoshaId
      }
      this.rec2 = data
      this.rec2.trMailSndrcv.sndrcvKbn = '01'
      this.setAddressItems()
      this.setAttachmentItems()
      this.rec2.scheduleData = Object.assign(scheduleBase, this.rec.trHacchuMeisai)
      this.rec2.juchuMeisaiId = this.juchuMeisaiId
    },
    setAddressItems: function () {
      const addressList = this.rec2.trMailSndrcv.trMailSndrcvAddressList.sort((a, b) => {
        if (a.addressKbn !== b.addressKbn) {
          if (a.addressKbn === '01' || b.addressKbn === '03') return -1
          return 1
        }
        return a.hyojiOrder - b.hyojiOrder
      })

      // システム設定
      var sysconf = indexeddb.getSystemConfig(this.systemConfigList, 'sagyo_irai_mail_initial_address')

      const self = this
      addressList.forEach((elem, index) => {
        // マスタチェック
        var isAddressIndex = self.jininAddressList.findIndex((x) => x.mailAddress === elem.mailAddress)

        // システム設定チェック
        var isSystemConfIndexCc = -1
        var isSystemConfIndexBcc = -1
        if (sysconf != null) {
          if (![null, ''].includes(sysconf.configValue1)) {
            isSystemConfIndexCc = sysconf.configValue1.indexOf(elem.mailAddress)
          }
          if (![null, ''].includes(sysconf.configValue2)) {
            isSystemConfIndexBcc = sysconf.configValue2.indexOf(elem.mailAddress)
          }
        }

        if (isAddressIndex >= 0 || isSystemConfIndexCc >= 0 || isSystemConfIndexBcc >= 0) {
          if (elem.addressKbn === '01') {
            if (self.toAddressItems === null) {
              self.toAddressItems = []
            }
            self.toAddressItems.push(elem.mailAddress)
          } else if (elem.addressKbn === '02') {
            if (self.ccAddressItems === null) {
              self.ccAddressItems = []
            }
            self.ccAddressItems.push(elem.mailAddress)
          } else if (elem.addressKbn === '03') {
            if (self.bccAddressItems === null) {
              self.bccAddressItems = []
            }
            self.bccAddressItems.push(elem.mailAddress)
          }
        } else {
          // jininAddressListに存在しない場合はdel_flgにTrueをセット
          elem.delFlg = true
        }
      })
    },
    setAttachmentItems: function () {
      this.rec2.trMailSndrcv.trMailSndrcvAttachmentList.forEach((elem, index) => {
        if (index === 0) this.attachmentItems = []
        this.attachmentItems.push({
          index: index,
          attachmentNm: elem.attachmentNm,
          attachmentNmDisp: elem.attachmentNmDisp,
          fileErrorMessage: elem.fileErrorMessage,
          file: {
            name: elem.attachmentNmDisp,
            size: null
          }
        })
        this.attachmentIndex = index
      })
    },
    sendMailSave: function (isSaveMessage, isIraiSave, isClose) {
      return new Promise(resolve => {
        const self = this
        if (this.validateAll(this.$refs) && self.sendMailRegisterValidate()) {
          this.Effects.loadStart()
          self.rec2.trMailSndrcv.trMailSndrcvAddressList = self.setSendAddressList()
          self.sendMailAttachmentListPromise().then((list) => {
            console.log(list)
            self.rec2.trMailSndrcv.trMailSndrcvAttachmentList = list
            return new Promise(resolve => {
              self.sendMailRegisterPromise().then(data => {
                console.log('registerRequestPromise', data)
                this.Effects.loadComplete()
                let message = data.summaryMessage && data.summaryMessage.message ? data.summaryMessage.message : ''
                let mailErrorFlg = false
                if (data.payload && data.payload.item2 && data.payload.item2.length) {
                  message = data.payload.item2.reduce((res, cur) => {
                    if (cur.message) {
                      res = (res ?? '') + '<br>' + cur.message
                      if (cur.message.indexOf('メールの送信に失敗しました。') !== -1) mailErrorFlg = true
                    }
                    return res
                  }, message)
                }
                console.log(message)
                // 取得情報設定
                if (data.payload && data.payload.item1) {
                  self.rec2.scheduleData = {
                    ...self.rec2.scheduleData,
                    // 更新日のみ上書き
                    updDate: data.payload.item1.trHacchuMeisai.updDate,
                    extUpdDate: data.payload.item1.trHacchuMeisai.extUpdDate,
                    kingakuUpdDate: data.payload.item1.trHacchuMeisai.kingakuUpdDate
                  }
                  self.rec2.trMailSndrcv = data.payload.item1.trMailSndrcv
                  self.trMailSndrcvId = data.payload.item1.trMailSndrcv.id
                  self.propsParam = {
                    ...self.propsParam,
                    trMailSndrcvId: data.payload.item1.trMailSndrcv.id,
                    ryokinCalcFlg5: data.payload.item1.trHacchuMeisai.ryokinCalcFlg5,
                    draftFlg: data.payload.item1.trMailSndrcv.draftFlg,
                    mailSndrcvYmd: data.payload.item1.trMailSndrcv.mailSndrcvYmd
                  }
                }

                // クローンデータ更新
                self.setCloneData2()
                if (isIraiSave) {
                  // 依頼情報の更新日を上書き
                  self.rec.trHacchuMeisai = {
                    ...self.rec.trHacchuMeisai,
                    updDate: data.payload.item1.trHacchuMeisai.updDate,
                    extUpdDate: data.payload.item1.trHacchuMeisai.extUpdDate,
                    kingakuUpdDate: data.payload.item1.trHacchuMeisai.kingakuUpdDate
                  }
                  self.sagyoIraiSave(false)
                }

                // 編集中のメール本文を削除
                localStorage.removeItem('mailText')
                self.isExistMailTextStorage = false

                self.$nextTick(() => {
                  if (data.isValid && !mailErrorFlg) {
                    if (isSaveMessage) modals.showToast(message, 2000, 400, null, 'success')
                    self.$emit('edited', self.propsParam)
                    if (!self.propsParam.draftFlg || isClose) {
                      self.closeDialog(true)
                    } else {
                      self.initialize(false)
                    }
                    resolve()
                  } else {
                    if (data.isValid) {
                      self.dataSaveFlg = true
                    }
                    if (isSaveMessage) modals.showError(message, 600)
                    resolve()
                  }
                })
              }).catch((e) => {
                console.log('error', e)
                modals.showError(e.message)
                this.Effects.loadComplete()
              })
            })
          })
        } else {
          modals.showAlert('COME0001').then(() => {})
        }
        resolve()
      })
    },
    sendMailRegisterPromise: function () {
      // メール本文改行置換
      // this.rec2.trMailSndrcv.mailText = this.rec2.trMailSndrcv.mailText.replaceAll('</p></p>', '<br/>')
      // this.rec2.trMailSndrcv.mailText = this.rec2.trMailSndrcv.mailText.replaceAll('<p>', '')
      let f
      if (this.trMailSndrcvId === 0) {
        console.log('★登録処理', this.rec2)
        f = this.HttpClient.post('/api/v1/Tgrcod002050/CreateWithChildren', this.rec2)
      } else {
        console.log('★更新処理', this.rec2)
        f = this.HttpClient.put(`/api/v1/Tgrcod002050/UpdateWithChildren?id=${this.trMailSndrcvId}`, this.rec2)
      }
      return f
    },
    sendMailRegisterValidate: function () {
      // 添付ファイルの重複チェック
      const attachmentCheck = this.attachmentItems.every((elem, index, self) => {
        var name1 = elem.attachmentNmDisp
        if (elem.file && elem.file.name) {
          // ファイル形式チェックがある場合はチェック
          name1 = elem.file.name
        }
        if (!name1) return true
        const fIdx = self.findIndex((item) => {
          const name2 = item.file ? item.file.name : item.attachmentNmDisp
          if (!name2) return false
          return name1 === name2
        })
        if (fIdx !== index) {
          this.attachmentItems[fIdx].fileErrorMessage = ATTACHMENTDUPLICATEERRORMESSAGE
          this.attachmentItems[index].fileErrorMessage = ATTACHMENTDUPLICATEERRORMESSAGE
          return false
        }
        return true
      })

      return attachmentCheck
    },

    /**
     * 全車両チェックON/OFF
     */
    onAllSharyoCheckFlgChange: function () {
      const self = this
      if (this.isLoading === false) {
        if (this.allSharyoCheckFlg) {
          if (this.uketsukeSharyoList) {
            this.uketsukeSharyoList.forEach((item) => {
              if (item.trHacchuMeisaiId === self.trHacchuMeisaiId || item.trHacchuMeisaiId === null) {
                self.rec.trSagyoMeisai.push(item)
              }
            })
          }
        } else {
          if (this.uketsukeSharyoList) {
            self.rec.trSagyoMeisai = []
          }
        }
      }
    },

    /**
     * 送信先設定
     */
    setSendAddressList: function () {
      // アドレス一覧登録形式変換
      // 表示順（hyojiOrder）はApi側で細かく設定し直す
      const curAdd = this.rec2.trMailSndrcv.trMailSndrcvAddressList
      const toAddress = this.toAddressItems.reduce((result, current, index) => {
        if (current) {
          var address = curAdd.find((elem) => elem.mailAddress === current)
          if (address) {
            address.addressKbn = '01'
            address.hyojiOrder = index + 1
            result.push(address)
          } else {
            result.push({
              id: 0,
              trMailSndrcvId: this.trMailSndrcvId,
              mailAddress: current,
              addressKbn: '01',
              hyojiOrder: index + 1
            })
          }
        }
        return result
      }, [])
      const ccAddress = this.ccAddressItems.reduce((result, current, index) => {
        if (current) {
          var address = curAdd.find((elem) => elem.mailAddress === current)
          if (address) {
            address.addressKbn = '02'
            address.hyojiOrder = index + 1
            result.push(address)
          } else {
            result.push({
              id: 0,
              trMailSndrcvId: this.trMailSndrcvId,
              mailAddress: current,
              addressKbn: '02',
              hyojiOrder: index + 1
            })
          }
        }
        return result
      }, [])
      const bccAddress = this.bccAddressItems.reduce((result, current, index) => {
        if (current) {
          var address = curAdd.find((elem) => elem.mailAddress === current)
          if (address) {
            address.addressKbn = '03'
            address.hyojiOrder = index + 1
            result.push(address)
          } else {
            result.push({
              id: 0,
              trMailSndrcvId: this.trMailSndrcvId,
              mailAddress: current,
              addressKbn: '03',
              hyojiOrder: index + 1
            })
          }
        }
        return result
      }, [])

      const allAddress = toAddress.concat(ccAddress, bccAddress)
      return allAddress
    },

    /**
     * 添付ファイル設定
     */
    sendMailAttachmentListPromise: function () {
      // 添付ファイル一覧登録形式変換
      // base64が遅いためリストPromiseを渡す
      return this.attachmentItems.reduce((promise, current, index) => {
        return promise.then(data => this.sendMailAttachmentPromise(data, current, index))
      }, Promise.resolve([]))
    },
    sendMailAttachmentPromise: function (result, current, index) {
      // 表示順（hyojiOrder）はApi側で細かく設定し直す
      console.log('sendMailAttachmentPromise', this.rec2.trMailSndrcv.trMailSndrcvAttachmentList, current)
      return new Promise((resolve) => {
        const curAtt = this.rec2.trMailSndrcv.trMailSndrcvAttachmentList
        if (current.attachmentNm) {
          // attachmentNm（フルパス）が存在 = 既存ファイル
          var attachmentPath = curAtt.find((elem) => elem.attachmentNmDisp === current.attachmentNmDisp)
          if (attachmentPath) {
            attachmentPath.attachmentNm = current.attachmentNm
            attachmentPath.hyojiOrder = index + 1

            result.push(attachmentPath)
            resolve(result)
          } else {
            result.push({
              id: 0,
              trMailSndrcvId: this.id,
              attachmentNm: current.attachmentNm,
              attachmentNmDisp: current.attachmentNmDisp,
              hyojiOrder: index + 1
            })
            resolve(result)
          }
        } else if (current.file && current.file.name) {
          // file（dd-file-inputのv-model）が存在 = アップロードファイル
          // base64文字列に変換
          const fr = new FileReader()
          fr.readAsDataURL(current.file)
          fr.addEventListener('load', () => {
            var attachmentFile = curAtt.find((elem) => elem.attachmentNmDisp.indexOf(current.file.name) !== -1)

            if (attachmentFile) {
              attachmentFile.uploadFile = fr.result
              attachmentFile.attachmentNmDisp = current.file.name
              attachmentFile.hyojiOrder = index + 1
              result.push(attachmentFile)
              resolve(result)
            } else {
              result.push({
                id: 0,
                trMailSndrcvId: this.id,
                uploadFile: fr.result,
                attachmentNmDisp: current.file.name,
                hyojiOrder: index + 1
              })
              resolve(result)
            }
          })
        } else {
          resolve(result)
        }
      })
    },

    /* -------------------------------------------------------------------------------------------------------------- *
     * 依頼削除
     * -------------------------------------------------------------------------------------------------------------- */
    onDeleteButtonClick: function () {
      modals.showConfirmYesNo('COMQ0003').then((ok) => {
        if (ok !== false && ok !== undefined) {
          this.sagyoIraiDelete()
        }
      })
    },
    sagyoIraiDelete: function (e) {
      console.log('delete')
      const self = this
      if (this.validateAll(this.$refs) && this.deleteValidate()) {
        this.Effects.loadStart()
        self.rec = self.cloneData.rec
        self.cloneShiharaiKakuteiFlg = self.cloneData.cloneShiharaiKakuteiFlg

        return new Promise(resolve => {
          self.HttpClient.post(`/api/v1/Tgrcod002030/DeleteWithChildren?id=${self.trHacchuMeisaiId}`, self.rec).then(data => {
            console.log('deleteRequestPromise', data)
            this.Effects.loadComplete()
            if (data.summaryMessage && data.summaryMessage.messageCd) {
              modals.showToastMessage(data.summaryMessage.messageCd, null, 2000, 400, null, 'success')
            }
            if (data.isValid) {
              this.$emit('deleted', self.trHacchuMeisaiId)
              this.closeDialog()
              resolve()
            } else {
              resolve()
            }
          }).catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            this.Effects.loadComplete()
            resolve()
          })
        })
      }
    },
    deleteValidate: function () {
      return true
    },

    /* -------------------------------------------------------------------------------------------------------------- *
     * 依頼入力補助
     * -------------------------------------------------------------------------------------------------------------- */
    onClickCloseIraisaki2: function () {
      this.isShowIraisaki2 = false
      this.rec.trHacchuMeisai.sagyoIraisakiId2 = null
      this.rec.trHacchuMeisai.sagyoTantoshaId2 = null
    },
    onClickCloseIraisaki3: function () {
      this.isShowIraisaki3 = false
      this.rec.trHacchuMeisai.sagyoIraisakiId3 = null
      this.rec.trHacchuMeisai.sagyoTantoshaId3 = null
    },
    // 郵便番号テキストボックスの仕様上、changeが使えない
    onToritsukesakiYubinInputFocus: function () {
      this.savedToritsukeYubinNo = this.rec.trHacchuMeisai.sagyobashoYubinNo
    },
    onToritsukesakiYubinInputBlur: function () {
      if (!this.isLoading && this.savedToritsukeYubinNo !== this.rec.trHacchuMeisai.sagyobashoYubinNo) {
        const yubinNo = this.rec.trHacchuMeisai.sagyobashoYubinNo.replaceAll('-', '')
        const self = this
        const x = new YubinBango.Core(yubinNo, function (addr) {
          self.rec.trHacchuMeisai = {
            ...self.rec.trHacchuMeisai,
            sagyobashoJusho1: addr.region + addr.locality + addr.street
          }
        })
        console.log('onToritsukesakiYubinInputBlur', x)
      }
      this.savedToritsukeYubinNo = null
    },
    onSagyobashoSearchButtonClick: function () {
      this.isShowSagyobashoSearchDialog = true
    },
    onSagyobashoSearchDialogClose: function (e) {
      console.log(e)
      if (e !== null) {
        this.isLoading = true
        this.rec.trHacchuMeisai.sagyobashoYubinNo = e.sagyobashoYubinNo
        this.rec.trHacchuMeisai.sagyobashoJusho1 = e.sagyobashoJusho1
        this.rec.trHacchuMeisai.sagyobashoJusho2 = e.sagyobashoJusho2
        this.rec.trHacchuMeisai.sagyobashoJusho3 = e.sagyobashoJusho3
        this.$nextTick(() => { this.isLoading = false })
      }
      this.isShowSagyobashoSearchDialog = false
    },

    /* -------------------------------------------------------------------------------------------------------------- *
     * メールテンプレート
     * -------------------------------------------------------------------------------------------------------------- */
    onTemplateButtonClick: function () {
      console.log('onTemplateButtonClick', this.templateId)

      if (this.templateId) {
        this.saveCheckBeforeOpenDialogPromise().then((ok) => {
          if (ok) {
            // メールテンプレート取得
            const self = this
            const param = {
              templateId: self.templateId,
              juchuMeisaiId: self.juchuMeisaiId,
              hacchuMeisaiId: self.trHacchuMeisaiId
            }
            self.Effects.loadStart()
            self.HttpClient
              .post('/api/v1/Tgrcod002051/TemplateTekiyo', param)
              .then((data) => {
                console.log('TemplateTekiyo', data)
                if (data.isValid) {
                  // 依頼車両のみを抽出
                  const item = data.payload.find((elem) => elem.sharyoFilterKbn === '01')
                  if (item) {
                    self.rec2.trMailSndrcv.mailTitle = item.templateTitle
                    self.rec2.trMailSndrcv.mailText = item.templateText
                    item.trMailSndrcvAttachmentList.forEach((elem, index) => {
                      if (index === 0) this.attachmentItems = []
                      this.attachmentItems.push({
                        index: index,
                        attachmentNm: elem.attachmentNm,
                        attachmentNmDisp: elem.attachmentNmDisp,
                        fileErrorMessage: elem.fileErrorMessage,
                        file: {
                          name: elem.attachmentNmDisp,
                          size: null
                        }
                      })
                      this.attachmentIndex = index
                    })
                  }
                } else {
                  if (data.summaryMessage && data.summaryMessage.message) {
                    modals.showError(data.summaryMessage.message)
                  }
                }
                self.setCloneData()
                this.Effects.loadComplete()
              })
              .catch((e) => {
                console.log('error', e)
                modals.showError(e.message)
                self.closeDialog(null)
                this.Effects.loadComplete()
              })
          }
        })
      } else {
        modals.showAlert('COME0008').then(() => {})
        this.$refs.templateId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001', ['テンプレート']))
      }
    },
    onClickRestoreMailText: function () {
      if (![undefined, null, ''].includes(localStorage.getItem('mailText'))) {
        if (![undefined, null, ''].includes(this.rec2.trMailSndrcv.mailText)) {
          modals.showConfirmYesNo('TGRCOQ17').then((ok) => {
            if (ok !== false && ok !== undefined) {
              this.rec2.trMailSndrcv.mailText = localStorage.getItem('mailText')
            }
          })
        } else {
          this.rec2.trMailSndrcv.mailText = localStorage.getItem('mailText')
        }
      }
    },

    /* 添付ファイル */
    addAttachmentsClick: function () {
      if (this.$refs.fileSelectInput && this.$refs.fileSelectInput.$refs && this.$refs.fileSelectInput.$refs.input) { this.$refs.fileSelectInput.$refs.input.click() }
    },
    changedFileSelect: function (e) {
      console.log(this.fileSelectInput)
      console.log(this.attachmentItems)
      this.fileSelectInput = []
      const _files = e
      var i = this.attachmentIndex + 1
      for (const file in _files) {
        if (!isNaN(file)) {
          // filesはファイル以外のデータが入っており、ファイルの場合のみキー名が数字になるため
          var x = {
            file: _files[file],
            index: i
          }
          this.attachmentItems.push(x)
          i = i + 1
        }
      }
      this.fileSelectInput = this.attachmentItems
    },
    onDrop (e) {
      if (this.trHacchuMeisaiId === 0) return

      e.preventDefault()
      e.stopPropagation()
      this.isDragging = false
      const _files = e.dataTransfer.files
      var i = this.attachmentIndex + 1
      for (const file in _files) {
        if (!isNaN(file)) {
          // filesはファイル以外のデータが入っており、ファイルの場合のみキー名が数字になるため
          var x = {
            file: _files[file],
            index: i
          }
          this.attachmentItems.push(x)
          i = i + 1
        }
      }
      this.fileSelectInput = this.attachmentItems
    },
    onDragEnter (e) {
      e.preventDefault()
      this.isDragging = true
      this.dragCount++
    },
    onDragLeave (e) {
      e.preventDefault()
      this.dragCount--
      if (this.dragCount <= 0) {
        this.isDragging = false
      }
    },
    removeFile (index) {
      const delIdx = this.attachmentItems.findIndex((x) => x.index === index)
      if (delIdx >= 0) {
        console.log('removeFile', index, delIdx)
        this.attachmentItems.splice(delIdx, 1)
        this.fileSelectInput = this.attachmentItems
      }
    },

    /* ================================================================================ *
     * テンプレートEXCELダウンロード
     * ================================================================================ */
    onTemplateExcelDownload: function (item) {
      this.isExcelDownloader = true
      const self = this
      self.HttpClient
        .requestFileByPost('/api/v1/Tgrcod0021/IraiTemplateExcelDownload', self.trHacchuMeisaiId)
        .then((data) => {
          if (data) {
            const sagyoYmd = self.rec.trHacchuMeisai.hatsuchiYmd ? self.rec.trHacchuMeisai.hatsuchiYmd.replaceAll('/', '') : '作業日指定なし'
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const elem = document.getElementById('download')
            self.isExcelDownloader = false
            elem.href = window.URL.createObjectURL(blob)
            elem.download = '作業依頼書_' + self.param.toritsukesakiNm + '_' + sagyoYmd + '.xlsx'
            elem.click()
          } else {
            modals.showToast('作業依頼書EXCELの作成に失敗しました', 2000, 400, null, 'error')
          }
        })
    },

    /* ================================================================================ *
     * 保存前チェック
     * ================================================================================ */
    saveCheckBeforeOpenDialogPromise: function (item) {
      const self = this
      return new Promise((resolve) => {
        const created = self.trHacchuMeisaiId <= 0 || self.trHacchuMeisaiId === null
        const target = self.getCloneTargetMethod()
        const modified = self._compareClone(target)
        const p = created || modified ? modals.showConfirmYesNo : self._dummyPromiseMethod
        if (p === self._dummyPromiseMethod) {
          resolve(true)
        } else {
          const messageCd = created ? 'TGRCOQ03' : 'TGRCOQ01'
          p(messageCd).then((ok) => {
            if (ok === false || ok === undefined) {
              resolve(false)
            } else {
              self.sagyoIraiSave(false).then((result) => {
                resolve(result)
              })
            }
          })
        }
      })
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.vitemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    // ----------------------------------------------------------------------
    // 差分チェック
    _compareClone: function (target) {
      console.log('_compareClone', target, this.cloneData)
      const t21 = JSON.stringify(target.rec.juchuKihonId)
      const c21 = JSON.stringify(this.cloneData.rec.juchuKihonId)
      const t22 = JSON.stringify(target.rec.juchuMeisaiId)
      const c22 = JSON.stringify(this.cloneData.rec.juchuMeisaiId)
      const t23 = JSON.stringify(target.rec.changedShiharaiKakuteiFlg)
      const c23 = JSON.stringify(this.cloneData.rec.changedShiharaiKakuteiFlg)
      const t24 = JSON.stringify(target.rec.mailDraftFlg)
      const c24 = JSON.stringify(this.cloneData.rec.mailDraftFlg)
      const t25 = JSON.stringify(target.rec.cloneTrSagyoMeisai)
      const c25 = JSON.stringify(this.cloneData.rec.cloneTrSagyoMeisai)

      const t31 = JSON.stringify(target.rec.trHacchuKihon)
      const c31 = JSON.stringify(this.cloneData.rec.trHacchuKihon)
      const t32 = JSON.stringify(target.rec.trHacchuMeisai)
      const c32 = JSON.stringify(this.cloneData.rec.trHacchuMeisai)

      const x21 = t21 !== c21
      const x22 = t22 !== c22
      const x23 = t23 !== c23
      const x24 = t24 !== c24
      const x25 = t25 !== c25
      const x31 = t31 !== c31
      const x32 = t32 !== c32

      return x21 || x22 || x23 || x24 || x25 || x31 || x32
    },
    _compareClone2: function (target) {
      const t11 = JSON.stringify(target.toAddressItem)
      const c11 = JSON.stringify(this.cloneData2.toAddressItem)
      const t12 = JSON.stringify(target.ccAddressItem)
      const c12 = JSON.stringify(this.cloneData2.ccAddressItem)
      const t13 = JSON.stringify(target.bccAddressItem)
      const c13 = JSON.stringify(this.cloneData2.bccAddressItem)
      const t14 = JSON.stringify(target.attachmentItems)
      const c14 = JSON.stringify(this.cloneData2.attachmentItems)

      const c2 = JSON.stringify(target.rec2)
      const t2 = JSON.stringify(this.cloneData2.rec2)

      const x11 = t11 !== c11
      const x12 = t12 !== c12
      const x13 = t13 !== c13
      const x14 = t14 !== c14
      const x2 = t2 !== c2

      return x11 || x12 || x13 || x14 || x2
    },
    // ----------------------------------------------------------------------
    dummyfunction () {
      return true
    }
  }
}
</script>
<style scoped>
  .template-select {
    width: 150px;
    background-color: white;
  }
  tr.disabledRow {
    background-color: silver;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper).disabledRow > td {
    background-color: silver !important;
  }
  ::v-deep .ql-container {
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 13px;
    height: var(--content-height) !important;
    margin: 0px;
    position: relative;
  }
</style>
